(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rideout-parts"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('rideout-parts')) {
  customElements.define('rideout-parts', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized || !this.querySelector('[data-model]')) return;
      this.initialized = true;
      const cards = Array.from(this.querySelectorAll('[data-models]'));
      const model = this.querySelector('[data-model]');
      const part = this.querySelector('[data-part]');
      const search = this.querySelector('[data-search]');
      const normalize = value => value.toLowerCase().replace(/[^a-z0-9]+/g, '');
      const addOptions = (select, values) => values.sort((a,b) => a.localeCompare(b, undefined, {numeric:true})).forEach(value => select.add(new Option(value,value)));
      addOptions(model, [...new Set(cards.flatMap(card => card.dataset.models.split('|').filter(Boolean)))]);
      addOptions(part, [...new Set(cards.map(card => card.dataset.partType).filter(Boolean))]);
      const params = new URLSearchParams(location.search);
      if (Array.from(model.options).some(o=>o.value===params.get('model'))) model.value = params.get('model');
      if (Array.from(part.options).some(o=>o.value===params.get('part'))) part.value = params.get('part');
      search.value = params.get('part_search') || '';
      const update = () => {
        let count = 0;
        const terms = search.value.trim().split(/\s+/).map(normalize).filter(Boolean);
        cards.forEach(card => {
          const haystack = normalize(card.dataset.searchText);
          const match = (!model.value || card.dataset.models.split('|').includes(model.value)) && (!part.value || card.dataset.partType === part.value) && terms.every(term => haystack.includes(term));
          card.hidden = !match;
          if (match) count++;
        });
        this.querySelectorAll('[data-quicktypes] button').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.type === part.value)));
        this.querySelector('[data-count]').textContent = this.dataset.countLabel + ': ' + count;
        this.querySelector('[data-empty]').hidden = count !== 0;
        const url = new URL(location.href);
        [['model', model.value],['part',part.value],['part_search',search.value]].forEach(([key,value])=>value ? url.searchParams.set(key,value) : url.searchParams.delete(key));
        history.replaceState(null,'',url);
      };
      const quickTypes = this.querySelector('[data-quicktypes]');
      if (quickTypes) Array.from(part.options).forEach(option => {
        const button = document.createElement('button');
        button.type = 'button'; button.textContent = option.textContent; button.dataset.type = option.value;
        button.addEventListener('click', () => { part.value = option.value; update(); });
        quickTypes.append(button);
      });
      model.addEventListener('change',update);
      part.addEventListener('change',update);
      search.addEventListener('input',update);
      this.querySelector('[data-reset]').addEventListener('click',()=>{model.value='';part.value='';search.value='';update();});
      update();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
